<template>
  <div
      class="io-color"
      :class="{ 'has-error': hasError }"
  >
    <div class="row align-items-center">
      <div class="col-auto align-self-center">
        <span
            class="picker-preview"
            :style="previewStyles"
            @click="showPicker"
        ></span>
      </div>
      <div class="col align-self-center">
        {{ label }}
      </div>
      <div class="col-auto align-self-center">
        <button
            v-if="rgba"
            type="button"
            class="btn btn-sm btn-link text-body"
            @click="clearValue"
        >
          <i class="far fa-trash"></i>
        </button>
      </div>
      <div class="col-auto align-self-center">
        <button
            type="button"
            class="btn btn-sm btn-link text-body"
            @click="showPicker"
        >
          <i class="far fa-ellipsis-h fa-2x"></i>
        </button>
      </div>
    </div>
    <input
        type="hidden"
        :name="name"
        ref="input"
        :value="rgba"
    >
    <div
        class="picker"
        :class="pickerClass"
        ref="picker"
    >
      <chrome-picker
          v-model="colors"
          @input="updateValue"
      />
    </div>
  </div>
</template>

<script>
import chrome from 'vue-color/src/components/Chrome.vue';

export default {
  name: 'IoColor',

  model: {
    prop: 'pickerColor',
    event: 'input',
  },

  props: {
    value: {
      type: String,
    },
    pickerColor: {
      default: '',
    },
    label: {
      required: true,
    },
    name: {
      required: true,
    },
    error: {
      type: [String, Array],
      required: false,
    },
  },

  components: {
    'chrome-picker': chrome,
  },

  data() {
    return {
      colors: this.pickerColor !== null ? this.pickerColor : '',
      pickerVisible: false,
      pickerPosition: 'top',
    };
  },

  mounted() {
    document.addEventListener('scroll', () => {
      this.setPosition();
    });
    document.addEventListener('click', (e) => {
      this.hidePicker(e);
    });
    this.setPosition();
  },

  computed: {
    errorMessage() {
      let message = null;
      if (typeof this.error === 'string' && this.error.trim().length > 0) {
        message = this.error.trim();
      } else if (Array.isArray(this.error) && this.error.length > 0) {
        const arrVal = this.error[0];
        if (typeof arrVal === 'string' && arrVal.trim().length > 0) {
          message = arrVal.trim();
        }
      }

      return message;
    },
    hasError() {
      return this.errorMessage !== null;
    },
    rgba() {
      if (typeof this.colors !== 'object') {
        return this.colors;
      }

      return `rgba(${this.colors.rgba.r},${this.colors.rgba.g},${this.colors.rgba.b},${this.colors.rgba.a})`;
    },

    previewStyles() {
      return {
        'background-color': this.rgba !== '' ? this.rgba : '#FFFFFF',
      };
    },

    pickerClass() {
      return `${this.pickerPosition} ${this.pickerVisible ? 'visible' : ''}`;
    },
  },

  methods: {
    updateValue() {
      this.$emit('input', this.rgba);
    },

    clearValue() {
      this.colors = '';
      this.$emit('input', '');
    },

    showPicker() {
      this.pickerVisible = true;
    },

    hidePicker(e) {
      if (typeof e !== 'undefined') {
        if (!(this.$el === e.target || this.$el.contains(e.target))) {
          this.pickerVisible = false;
        }
      } else {
        this.pickerVisible = false;
      }
    },

    setPosition() {
      const windowHeight = window.innerHeight;
      const posY = this.$el.getBoundingClientRect().y;
      this.pickerPosition = (posY > (windowHeight / 2)) ? 'top' : 'bottom';
    },
  },
};
</script>

<style lang="scss">
@use 'sass:math';

.io-color {
  background-color: #F2F5F8;
  position: relative;

  > .row {
    min-height: 65px;
    height: 65px;

    .picker-preview {
      height: 32px;
      width: 32px;
      display: block;
      margin-left: math.div(65px - 32px, 2);
    }
  }

  > .picker {
    position: absolute;
    display: none;
    right: 0;
    transition: all .225s ease-out;
    z-index: 10;

    &.visible {
      display: block;
    }

    &.top {
      top: 0;
      transform: translateY(-100%);
    }

    &.bottom {
      top: 100%;
      transform: translateY(0%);
    }
  }

  &.has-error {
    border: 1px solid var(--bs-danger);
  }

  .vc-chrome-toggle-icon {
    left: 12px;
  }
}
</style>
